import { render } from "./BookingHours.vue?vue&type=template&id=253e876e&scoped=true"
import script from "./BookingHours.vue?vue&type=script&lang=js"
export * from "./BookingHours.vue?vue&type=script&lang=js"

import "./BookingHours.vue?vue&type=style&index=0&id=253e876e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253e876e"]])

export default __exports__